import {
	ContractorTypeLabels,
	ContractorTypeValues,
	DesignerType,
	DesignerTypeLabels,
} from "@dune/types";
import { createParser } from "nuqs";

export const parseAsContractorType = createParser({
	parse: (value: string): ContractorTypeValues | "all" | null => {
		if (!value) return null;
		if (value === "all") return "all";
		const validKeys = Object.keys(ContractorTypeLabels);
		if (validKeys.includes(value)) {
			return value as ContractorTypeValues;
		}
		return null;
	},
	serialize: (value: ContractorTypeValues | "all" | null) => value || "",
});

export const parseAsDesignerType = createParser({
	parse: (value: string): DesignerType | "all" | null => {
		if (!value) return null;
		if (value === "all") return "all";
		const validKeys = Object.keys(DesignerTypeLabels);
		if (validKeys.includes(value)) {
			return value as DesignerType;
		}
		return null;
	},
	serialize: (value: DesignerType | "all" | null) => value || "",
});

export const parseAsInsurerType = createParser({
	parse: (value: string): string | "all" | null => {
		if (!value) return null;
		if (value === "all") return "all";
		return value;
	},
	serialize: (value: string | "all" | null) => value || "",
});

export const isValidContractorType = (
	key: string,
): key is ContractorTypeValues => {
	return Object.keys(ContractorTypeLabels).includes(key);
};

export const isValidDesignerType = (key: string): key is DesignerType => {
	return Object.keys(DesignerTypeLabels).includes(key);
};
